import { useTranslation, Footer as FooterBase } from "@mozioinc/ui";

export const Footer = () => {
  const { t } = useTranslation("ui:footer");

  return (
    <FooterBase
      className="max-w-5xl"
      navLinks={[
        {
          href: "https://www.mozio.com/about",
          content: t("About Us"),
        },
        {
          href: "https://moziogroup.zendesk.com/hc/en-us/categories/22088455703565-Airport-Parking",
          content: t("FAQ"),
        },
        {
          href: "https://www.moziogroup.com/",
          content: t("Partners"),
        },
        {
          href: "https://www.mozio.com/provider",
          content: t("Providers"),
        },
        {
          href: "https://www.mozio.com/guide/resort",
          content: t("Resorts"),
        },
        {
          href: "https://www.mozio.com/guide/airport",
          content: t("Airports"),
        },
      ]}
      legalLinks={[
        {
          href: "https://www.mozio.com/privacy-policy",
          content: t("Privacy Policy"),
        },
        {
          href: "/parking/terms-and-conditions",
          content: t("Terms and Conditions"),
        },
        {
          href: "https://www.mozio.com/en-us/imprint",
          content: t("Imprint"),
        },
      ]}
    />
  );
};
